<app-page>
    <br>
    <h1 align="center">{{ 'page_not_found' | translate }}</h1>
    <p align="center"><button mat-flat-button class="button" (click)="goToHomePage()" align="center">{{ 'return_home' | translate }}</button></p>
</app-page>